<template>
    <v-sheet  color="bgtopology"  class="ma-4 defaultCard ">
        <v-row class="mb-4" justify="space-between">
            <span  class="titlePages">{{ t('title.monitoring') }}</span>
        </v-row>
        <v-row justify="start" class="mb-5 mr-2">
            <v-menu :location="'end'">
                <template v-slot:activator="{ props }">
                    <v-btn
                    v-bind="props"
                    icon="mdi-menu"
                    variant="plain"
                    >
                    </v-btn>
                </template>
                <v-list nav>
                    <v-list-item
                    v-for="(item, i) in itemsColumns"
                    :key="i"
                    :value="item.value"
                    :title="item.title"
                    class="nav_item_title" 
                    :disabled="item.disabled"
                    link 
                    @click="showDialog(item.value)"
                    ></v-list-item>
                </v-list>
                </v-menu>
        </v-row>
            <v-data-table
            v-if="sortedItems.length > 0"
            :headers="ALLHEADER"
            :items="sortedItems"
            table-class-name="customize-table"
            :hide-footer="sortedItems.length < 5"
            >    
                <template v-slot:headers>

                    <VueDraggableNext class="dragArea list-group w-full" :list="ALLHEADER" tag="tr"  @change="changeHeader(ALLHEADER)">
                        <td v-for="(item,i) in ALLHEADER" :key="item.key??i"  @click="sortBy(item.key)">
                            {{ item.title?.toUpperCase() }}
                            <span v-if="sortKey === item.key">
                                {{ sortDesc ? '🔽' : '🔼' }}
                            </span>
                        </td> 
                    </VueDraggableNext>                    
                </template>  

                <template v-slot:item="{item}">
                    <tr class="monitoreoTR" @click="postURL(item)">
                        <td v-for="(header,i) in ALLHEADER" :key="i"> {{ item[`${header.key?? 'ip'}` ]}}</td>
                    </tr>
                </template>  
            
            </v-data-table>
            <v-row v-else justify="center" class="ma-4">
                <Prog_circular/>
            </v-row>
        
        <v-divider  thickness="5" color="white" opacity="1" class="mt-4 mb-4"></v-divider>
        <v-sheet v-if="false" color="transparent"  class="defaultCard ma-0 pa-0">
            <v-row class="ma-0 mb-2">
                <span class="titlePages ma-0">{{ t('labels.location') }}</span>
            </v-row>
            <v-row class="ma-4" justify="center">
                <v-sheet width="60%">
                    <div id="map"></div>
                </v-sheet>
            </v-row>
        </v-sheet>
    </v-sheet>
    
    <v-dialog v-model="dialog" width="55%" >
        <v-card class="card_dialog pa-4" color="background"> 
            <v-row class="ma-0">
                <v-col class="pa-0 py-2" cols="12" align-self="center">
                    <span class="subtitleDashboard"> Agregar Columna</span>
                </v-col>
                <v-col class="pa-0 py-2 pr-2" cols="6">
                    <v-text-field
                    hide-details
                    density="compact"
                    variant="outlined"
                    v-model="textColumn"
                    label="Nombre Columna"
                    />
                </v-col>
                <v-col  class="pa-0 py-2 pl-2" cols="6">
                    <v-select
                    hide-details
                    density="compact"
                    variant="outlined"
                    v-model="columnSelected"
                    :items="columnsList"
                    label="Valor Columna"
                    /> 
                </v-col>
            </v-row>
            <v-row class="ma-0 my-2">
                <v-btn block color="success" @click="agregarColumna" :disabled="textColumn === '' || columnSelected === ''">Agregar</v-btn>
            </v-row>
            
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDelete" width="55%" >
        <v-card class="card_dialog pa-4" color="background"> 
            <v-row class="ma-0">
                <v-col class="pa-0 py-2" cols="12" align-self="center">
                    <span class="subtitleDashboard"> Eliminar Columna</span>
                </v-col>
                <v-col  class="pa-0 py-2 pl-2" cols="12">
                    <v-select
                    hide-details
                    density="compact"
                    variant="outlined"
                    v-model="columnSelected"
                    :items="allColumnsList"
                    label="Valor Columna"
                    /> 
                </v-col>
            </v-row>
            <v-row class="ma-0 my-2">
                <v-btn block color="success" @click="eliminarColumna" :disabled="columnSelected === ''">Eliminar</v-btn>
            </v-row>
            
        </v-card>
    </v-dialog>
</template>

<script setup lang="ts">
import { ref, Ref, onMounted, onUnmounted, computed }      from 'vue';

/********************************
 ********** CONSTANTES **********
 *******************************/
import CONSTAPIS  from '@/constants/apis'
import { MONITOREO } from '@/constants/monitoring'

/********************************
 ********** COMPONENTS **********
 *******************************/
import { VueDraggableNext } from 'vue-draggable-next';
import Prog_circular     from '@/components/PrincipalComponents/Prog_circular.vue';

/********************************
 ********** INTERFACES **********
 *******************************/
import { ALLHEADERFIX,HEADERFIX, DEFAULT_ITEMS } from '@/interfaces/SmartLink/Tables';
import { MONITORING } from '@/interfaces/GestorHCGLINK/Equips';
import { STRINGS } from '@/interfaces/SmartLink/General';

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

/********************************
 *********** FUNCTION ***********
 *******************************/
import { getInfoByIP } from '@/functions/project';

const sortKey = ref('')
const sortDesc = ref(false)

function sortBy(key: string) {
  if (sortKey.value === key) {
    sortDesc.value = !sortDesc.value
  } else {
    sortKey.value = key
    sortDesc.value = false
  }
}

// Lista ordenada computada
const sortedItems = computed(() => {
  if (!sortKey.value) return arrayOfObjects.value

  return [...arrayOfObjects.value].sort((a, b) => {
    const aVal = a[sortKey.value]
    const bVal = b[sortKey.value]

    if (aVal == null) return 1
    if (bVal == null) return -1

    if (aVal === bVal) return 0
    if (sortDesc.value) {
      return aVal < bVal ? 1 : -1
    } else {
      return aVal > bVal ? 1 : -1
    }
  })
})

const postURL = (item: any) => {
    window.open(`http://${item.ip}/webfig/#interfaces`, "_blank", "noopener,noreferrer");
}



const HEADERS:Ref<ALLHEADERFIX> = ref({
    principal : [            
        {title : 'status',           key: 'status',            sortable:true},
        // {title : 'name',             key: 'fName',             sortable:true},
        {title : 'name',             key: 'name',              sortable:true},
        {title : 'ip',               key: 'ip',                sortable:true},
        {title : 'tipo',             key: 'tipo',              sortable:true},
        {title : 'imei',             key: 'imei',              sortable:true},
        {title : 'Primary Band',     key: 'primary-band',      sortable:true},
        {title : 'DL Modulation',    key: 'dl-modulation',     sortable:true},
        {title : 'CQI',              key: 'cqi',               sortable:true},
        {title : 'RI',               key: 'ri',                sortable:true},
        {title : 'MCS',              key: 'mcs',               sortable:true},
        {title : 'rssi (dBm)',       key: 'rssi',              sortable:true},
        {title : 'rsrp (dBm)',       key: 'rsrp',              sortable:true},
        {title : 'rsrq (dB)',        key: 'rsrq',              sortable:true},
        {title : 'sinr (dB)',        key: 'sinr',              sortable:true},
        {title : 'APN',              key: 'apn-profiles',      sortable:true},
        {title : 'network-mode',     key: 'network-mode',      sortable:true},
        {title : 'uptime',           key: 'session-uptime',    sortable:true},
        {title : 'enb-id',           key: 'enb-id',            sortable:true},
        {title : 'phy-cellid',       key: 'phy-cellid',        sortable:true},
    ],
    secundary: [
        {title : 'phy-cellid',       key: 'phy-cellid',        sortable:true},
    ]
})


const columnsList:Ref<string[]> = ref([])
const allColumnsList:Ref<string[]> = ref([])
const columnSelected = ref('');
const textColumn    = ref('');


const ALLHEADER:Ref<HEADERFIX[]> = ref(HEADERS.value.principal)

const changeHeader = (header:Array<HEADERFIX>) => {
    ALLHEADER.value = header;
    getAllColumnsList()
}

const itemsColumns = ref([
    { title: 'Agregar Columnas', value: 1, disabled:computed(() => columnsList.value.length == 0 ) },
    { title: 'Eliminar Columnas', value: 2, disabled:computed(() => allColumnsList.value.length == 0 )},
]);

const agregarColumna = () => {
    ALLHEADER.value.push({
        title       : textColumn.value??'Texto Default',
        key         : columnSelected.value,
        sortable    : true,
    })
    columnsList.value = columnsList.value.filter(item => item !== columnSelected.value); //Elimino item del array para no mostrarlo
    textColumn.value = '';
    columnSelected.value = '';
    getAllColumnsList();
}

const eliminarColumna = () => {
    ALLHEADER.value = ALLHEADER.value.filter((item:HEADERFIX) => item.key !== columnSelected.value); //elimino el elemento seleccionado
    columnsList.value.push(columnSelected.value);
    columnSelected.value = '';
    getAllColumnsList();
}

const dialog        = ref(false);
const dialogDelete  = ref(false);
const showDialog = (valor:number) => {
    if(valor === 1) dialog.value = true;
    if(valor === 2) dialogDelete.value = true;
}

let ws: WebSocket | null = null;
const finalObject = ref<MONITORING>({});
// const arrayOfObjects = ref<DEFAULT_ITEMS[]>([]);
const arrayOfObjects = ref<any[]>(MONITOREO);

const getAllColumnsList = () => {
    allColumnsList.value = []
    ALLHEADER.value.forEach((item:HEADERFIX) => {
        allColumnsList.value.push(item.key)
    })
}

/**
 * Llama a la funcion getInfoByIP
 * Envia el parametro del valor que desea obtener
 * Recibe objeto {
 *  ip : tipo
 * }
 * se Usa para colocar el tipo de los equipos en la tabla
 */
const finalTypeByIP:Ref<STRINGS> = ref(getInfoByIP('tipo'))
    
/**
 * Llama a la funcion getInfoByIP
 * Envia el parametro del valor que desea obtener
 * Recibe objeto {
 *  ip : name
 * }
 * se Usa para colocar el name de los equipos en la tabla
 */
const finalNameByIP:Ref<STRINGS> = ref(getInfoByIP('name'))

onMounted( async() => {
    getAllColumnsList();

    /**
     * LLama al websocket y recibe datos constatemente
     * Va almacenando en la variable arrayOfObjects
     */
    // ws = new WebSocket(`http://192.168.3.81/cloud/monitoreo/update`);
    // ws = new WebSocket(`${CONSTAPIS.APIS.value.webSocket.wss}`);

    // ws.onopen = () => console.log("Conectado al WebSocket");

    // ws.onmessage = (event) => {
    //     let finalData = JSON.parse(event.data);
    //     console.log(finalData)
    //     if(finalData.ip){
    //         if(!finalObject.value[finalData.ip]){
    //             finalObject.value[finalData.ip] = {}
    //         }
    //         finalObject.value[finalData.ip] = finalData;
            
    //         arrayOfObjects.value = Object.keys(finalObject.value).map(key => {
    //             return {
    //                 ip: key,
    //                 tipo: finalTypeByIP.value[key],
    //                 fName: finalNameByIP.value[key],
    //                 ...finalObject.value[key]
    //             };
    //         });
    //     }
    // };

    // ws.onerror = () => console.error("Habilitar la API: ", CONSTAPIS.APIS.value.webSocket.wss);

})
onUnmounted(() => {
    // if (ws) {
    //     ws.close(); // Cerrar la conexión WebSocket
    //     console.log('WebSocket cerrado al desmontar el componente');
    // }
});

</script>

<style>
.borderStyle{
    border-bottom: 2px solid rgb(var(--v-theme-colorText)) !important;
}
.monitoreoTR:hover{
    cursor: pointer;
    background-color: rgb(41, 35, 65) !important;
}
</style>
